import isNil from 'lodash/isNil';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { getStaticAssetUrl } from 'utils/url';

interface IProjectSocialLink {
  link?: string;
  icon: 'telegram' | 'discord' | 'twitter' | 'medium';
}

export const ProjectSocialLink = ({ link, icon }: IProjectSocialLink) => {
  const redirectTo = (url: string) => window.open(url, '_blank');

  return (
    <div
      onClick={() => !isNil(link) && redirectTo(link)}
      className={twMerge(
        'flex h-11 w-11 cursor-pointer items-center justify-center hover:opacity-65',
        isNil(link) && 'cursor-no-drop opacity-65'
      )}
    >
      <Image
        width={24}
        height={24}
        src={getStaticAssetUrl(`/sfi/static/logo/${icon}.svg`)}
        alt={icon}
      />
    </div>
  );
};
